import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { AlertCircle } from "lucide-react";
import { useNavigate } from "react-router";

interface NotAMemberPageProps {
  workspaceId: string;
}

export function NotAMemberPage({ workspaceId }: NotAMemberPageProps) {
  const navigate = useNavigate();

  const handleGoToWorkspaces = () => {
    navigate("/workspaces");
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <Card className="w-full max-w-md m-2">
        <CardHeader>
          <div className="flex items-center gap-2 text-red-600 mb-2">
            <AlertCircle className="h-5 w-5" />
            <span className="text-sm font-medium">Access Denied</span>
          </div>
          <CardTitle>You're not a member of this workspace</CardTitle>
          <CardDescription>
            The workspace you're trying to access either doesn't exist or you
            don't have permission to view it.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-sm text-muted-foreground">
            <p>
              Workspace ID:{" "}
              <code className="px-1 py-0.5 bg-gray-100 rounded text-xs">
                {workspaceId}
              </code>
            </p>
          </div>
        </CardContent>
        <CardFooter className="flex gap-2">
          <Button onClick={handleGoToWorkspaces}>View All Workspaces</Button>
        </CardFooter>
      </Card>
    </div>
  );
}
